import axios from '@/utils/http';

export default () => {
  return axios
    .get('/landun')
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};
